;
( function( $, window, document, undefined )
{
    'use strict';

    var helpers = function( element, options )
    {
    };

    helpers.prototype = {

        highlight : function( data, search )
        {
            return data.replace( new RegExp( "(" + this.preg_quote( search ) + ")" , 'gi' ), "<strong>$1</strong>" );
        },

        preg_quote : function( str )
        {
            // http://kevin.vanzonneveld.net
            // +   original by: booeyOH
            // +   improved by: Ates Goral (http://magnetiq.com)
            // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
            // +   bugfixed by: Onno Marsman
            // *     example 1: preg_quote("$40");
            // *     returns 1: '\$40'
            // *     example 2: preg_quote("*RRRING* Hello?");
            // *     returns 2: '\*RRRING\* Hello\?'
            // *     example 3: preg_quote("\\.+*?[^]$(){}=!<>|:");
            // *     returns 3: '\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:'

            return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
        }

    };

    $.fn.helpers = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( document )
          , instance = $item.data( 'helpers' );

        if( !instance )
        {
            instance = new helpers( this, options );
            $item.data( 'helpers', instance );
        }

        if( typeof options === 'string' )
        {
            return instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );